import React from 'react';
import { read } from 'react-read';
import { captureException } from '@sentry/browser';
import { webgateFetch, WEBGATE_DOMAIN } from '../lib/api';
import { withHooks } from '../lib/withHooks';
import { createLoader } from '../dataloader';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function load(_key: 0) {
  const response = await webgateFetch(
    `${WEBGATE_DOMAIN}/s4x-me/v0/me/features`,
  );

  try {
    if (!response.ok) return {};
    const { features } = (await response.json()) as Response;
    return features;
  } catch (error) {
    captureException(error);
    return {};
  }
}

export const featuresLoader = createLoader(load);

if (process.env.NODE_ENV !== 'test') {
  // eagerly start loading
  featuresLoader.load(0);
}

export function useCurrentUserFeatures() {
  const features = React.useMemo(() => {
    return read(featuresLoader.load(0));
  }, []);

  return features;
}

export const withCurrentUserFeatures = withHooks(() => ({
  features: useCurrentUserFeatures(),
}));

type Response = {
  features: {
    [s: string]: string;
  };
};
